import styles from "./Logo.module.css";
import { useEffect, useState } from "react";
import { isMobileViewHook } from "@/customHooks/isMobileViewHook";
import { useTheme } from "@/components/ThemeSwitcher";
import { IconDark, IconLight, LogoDark, LogoLight } from "@/constant/imagePath";
import { cn } from "@/helper/HelperFunction";

export default function Logo({
  variant = "logo",
  type,
  isCollapsed,
  disableMobileChange = false,
  customClass,
}) {
  const { theme } = useTheme();
  const [mobile, setMobile] = useState(false);
  useEffect(() => {
    if (!disableMobileChange) {
      isMobileViewHook(setMobile, 480);
    }
  }, [disableMobileChange]);

  const logoSrcVariant = (theme = "light") => {
    return {
      icon: IconDark,
      logo:
        (mobile && !disableMobileChange) || isCollapsed
          ? theme === "light"
            ? LogoDark
            : LogoLight
          : theme === "light"
          ? LogoDark
          : LogoLight,
      footer: theme === "light" ? LogoDark : LogoLight,
    };
  };

  return (
    <div
      className={cn(
        styles.logo,
        type === "footer" && styles.footerLogo,
        type === "header" && styles.headerLogo,
        customClass
      )}
    >
      <img src={logoSrcVariant(theme)[variant]} alt="Logo" />
    </div>
  );
}
